/* global api, apiUrl */
import axios from 'axios';

// OAuth endpoints live at the API root, not under /api/.
const oauthBaseUrl = () => apiUrl.replace(/api\/?$/, '');

class AgentSettingsApi {

    getCurrentBusiness() {
        var url = apiUrl + 'agentSettings/currentBusiness';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    setEnabled(enabled) {
        var url = apiUrl + 'agentSettings/currentBusiness';
        return api.call('put', url, { enabled: enabled })
            .then(({ data }) => {
                return data
            });
    }

    disconnect(id) {
        var url = apiUrl + 'agentSettings/connections/' + encodeURIComponent(id);
        return api.call('delete', url)
            .then(({ data }) => {
                return data
            });
    }

    getActivity(page = 1, pageSize = 10) {
        var url = apiUrl + `agentSettings/activity?page=${page}&pageSize=${pageSize}`;
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getConsent(clientId) {
        var url = apiUrl + 'agentSettings/consent?clientId=' + encodeURIComponent(clientId || '');
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    /**
     * Sends the user's decision for a pending OAuth request. `params` are the original
     * authorization request parameters from the consent page URL. Resolves to the URL
     * the browser must go to next (back to the AI app).
     */
    decide(params, decision, businessId, optionalScopes = []) {
        const body = new URLSearchParams(params);
        body.set('decision', decision);
        if (businessId) body.set('business_id', businessId);
        body.set('granted_optional_scopes', optionalScopes.join(' '));
        return axios.post(oauthBaseUrl() + 'connect/authorize', body, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Niagaku-Consent': '1' },
        }).then(({ data }) => data.redirectUri);
    }
}

export default AgentSettingsApi;
